import { Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React, { useState } from 'react';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import {
  Accordion,
  AccordionProps,
} from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import GroupsController from 'src/components/oneCorp/features/MealCredit/components/Groups/GroupsController';

interface GroupsAccordionProps extends Omit<AccordionProps, 'header' | 'body'> {
  mealCredit: IMealCredit;
  corpId: string;
  fetchMealCredit: () => Promise<void>;
}

export function GroupsAccordion({
  mealCredit,
  corpId,
  fetchMealCredit,
  ...props
}: GroupsAccordionProps): JSX.Element {
  const [groupsCount, setGroupsCount] = useState<number>(0);

  return (
    <Stack y="xxx-lg" bg="globals.white">
      <Accordion
        {...props}
        header={() => <Heading variant="h6">Groups ({groupsCount})</Heading>}
        body={() => (
          <GroupsController
            corpId={corpId}
            mealCreditId={mealCredit.id}
            mealCredit={mealCredit}
            getMealCreditDetails={fetchMealCredit}
            onTotalResultsChange={(count) => setGroupsCount(count)}
          />
        )}
      />
    </Stack>
  );
}
